import configs from 'config-base';
import { apiClient } from '@/services/base';
import StringHTMLBuilder from '@/lib/StringHTMLBuilder';
import FaqApiService from '@/api/content/faq';
import AboutUsApiService from '@/api/content/about';
import ContactUsApiService from '@/api/content/contactUs';
import ReviewPolicyApiService from '@/api/content/reviewPolicy';

const webAdminDomainUrl = configs.webAdminUrl;

export default function useAllertEdit(id: string, allertType: string, isAdmin: boolean, url?: string, page?: string) {
  const getPageEditUrl = async (page: string | undefined) => {
    switch (page) {
      case 'faq':
        const faqContentService = new FaqApiService(apiClient, StringHTMLBuilder);
        const { data: faqEditUrl } = await faqContentService.getFAQEditUrl();
        return faqEditUrl;
      case 'about':
        const aboutContentService = new AboutUsApiService(apiClient, StringHTMLBuilder);
        const { data: aboutEditUrl } = await aboutContentService.getAboutUsEditUrl();
        return aboutEditUrl;
      case 'contact':
        const contactUsContentService = new ContactUsApiService(apiClient, StringHTMLBuilder);
        const { data: contactUsEditUrl } = await contactUsContentService.getContactUsEditUrl();
        return contactUsEditUrl;
      case 'review-policy':
        const reviewPolicyContentService = new ReviewPolicyApiService(apiClient, StringHTMLBuilder);
        const {data: reviewPolicyEditUrl} = await reviewPolicyContentService.getReviewPolicyEditUrl();
        return reviewPolicyEditUrl;
      default:
        break;
    }
  };

  if (!isAdmin) return '';

  if (url !== '') return url;

  if (page !== '') return getPageEditUrl(page);

  return `${webAdminDomainUrl}${allertType}.php?id=${id}`;
}
